import React, { useEffect, createElement } from 'react';
import { MarqueeBanner } from './components/MarqueeBanner';
import { HeroSection } from './components/HeroSection';
import { WhatIsSection } from './components/WhatIsSection';
import { PainPoints } from './components/PainPoints';
import { ReframeSection } from './components/ReframeSection';
import { MechanismSection } from './components/MechanismSection';
import { TomesSection } from './components/TomesSection';
import { BonusSection } from './components/BonusSection';
import { RoadmapSection } from './components/RoadmapSection';
import { ForWhomSection } from './components/ForWhomSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { PricingSection } from './components/PricingSection';
import { OroDetailSection } from './components/OroDetailSection';
import { PopUps } from './components/PopUps';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const s = document.createElement('script');
    s.async = true;
    s.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(s);
    f.fbq('init', '1374426524177378');
    f.fbq('track', 'PageView');
  }, []);
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-deep text-text-primary font-body overflow-x-hidden" data-id="element-0">
      <MarqueeBanner data-id="element-1" />
      <HeroSection onCtaClick={scrollToPricing} data-id="element-2" />
      <WhatIsSection data-id="element-3" />
      <PainPoints onCtaClick={scrollToPricing} data-id="element-4" />
      <ReframeSection data-id="element-5" />
      <MechanismSection data-id="element-6" />
      <TomesSection data-id="element-7" />
      <BonusSection onCtaClick={scrollToPricing} data-id="element-8" />
      <RoadmapSection data-id="element-9" />
      <ForWhomSection data-id="element-10" />
      <TestimonialsSection data-id="element-11" />
      <GuaranteeSection data-id="element-12" />
      <PricingSection data-id="element-13" />
      <OroDetailSection data-id="element-14" />
      <FAQSection data-id="element-15" />
      <Footer data-id="element-16" />
      <PopUps data-id="element-17" />
    </div>;
}